export const latestRelease = {
  date: 'September 2, 2026',

  title: "Apollo's latest update:",

  summary:
    'Module 1 now supports Physical Examination, giving learners an additional source of clinical information when assessing and diagnosing AI patients.',

  highlights: [
    'Order a Physical Examination during Module 1 consultations',
    'Review patient-specific physical examination findings',
    'Use physical signs alongside history, vital signs, laboratory tests, imaging, and other investigations',
    'Build a more complete clinical picture before submitting a diagnosis',
  ],
};